<script lang="ts">
  import { ApiError, errorMessage, issueMessages } from '../api/errors';
  import { fa } from '../i18n/fa';
  import Alert from './Alert.svelte';

  /** Error text from the server (Persian) plus the trace id support can search for. */
  let { error }: { error: unknown } = $props();
  const issues = $derived(issueMessages(error));
</script>

<Alert tone="error">
  <p>{errorMessage(error)}</p>
  {#if issues.length > 0}
    <ul class="mt-1 list-disc ps-5">
      {#each issues as m (m)}<li>{m}</li>{/each}
    </ul>
  {/if}
  {#if error instanceof ApiError && error.traceId}
    <p class="mt-1 text-xs opacity-80">{fa.app.traceId}: <bdi dir="ltr">{error.traceId}</bdi></p>
  {/if}
</Alert>
